import { createReducer, createAction } from '@reduxjs/toolkit';
import { authCompanyApi } from 'services/authCompany';

export const resetAuthCompanyAction = createAction('RESET_AUTH');

const initialState = {
  company_user : null,
}

const authCompanyReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(resetAuthCompanyAction, () => {
      localStorage.removeItem('adminToken')
      return initialState
    })
    .addMatcher(authCompanyApi.endpoints.getCompanyUser.matchFulfilled, (state, action) => {
      state.company_user = action.payload.company_user;
    })
})

export default authCompanyReducer;